module.exports = __webpack_public_path__ + "img/symbol_7.c78af446.png";